import * as Sentry from '@sentry/react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { CreatePasswordPage } from './CreatePasswordPage/CreatePasswordPage';
import { HomePage } from './HomePage/HomePage';
import { NotFoundPage } from './NotFoundPage/NotFoundPage';
import { RecoverPasswordPage } from './RecoverPasswordPage/RecoverPasswordPage';
import { GenericErrorFallback } from './shared/components/GenericErrorFallback';
import { Layout } from './shared/components/Layout';
import { LocaleProvider } from './shared/intl/LocaleProvider';

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

export default function App() {
  return (
    <LocaleProvider>
      <Sentry.ErrorBoundary fallback={GenericErrorFallback}>
        <BrowserRouter>
          <SentryRoutes>
            <Route path="/" element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="create-password/*" element={<CreatePasswordPage />} />
              <Route path="password-recovery/*" element={<RecoverPasswordPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </SentryRoutes>
        </BrowserRouter>
      </Sentry.ErrorBoundary>
    </LocaleProvider>
  );
}
